export const WC_PROJECT_ID = 'e24844c5deb5193c1c14840a7af6a40b';
export const TREZOR_MANIFEST = {
  appUrl: 'https://widget.rango.exchange/',
  email: 'hi+trezorwidget@rango.exchange',
};
export const TON_CONNECT_MANIFEST_URL =
  'https://raw.githubusercontent.com/rango-exchange/assets/refs/heads/main/manifests/tonconnect/manifest.json';
